import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-body-large',
    templateUrl: './body-large.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BodyLargeComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
